"use client";

// import { Label } from "@/components/ui/label";
// import { Input } from "@/components/ui/input";
// import { TooltipWrapper } from "./ui/tooltip-wrapper";
import { useWidgetStore } from "../stores/widget-store";
import { Check } from "lucide-react";
import PipetteIcon from "../icons/pipette";
import { useRef } from "react";

export function ColorPicker() {
  const COLORS = [
    "#14142A",
    "#1863DC",
    "#115A23",
    "#FF3B30",
    "#5856D6",
    "#FF2E55",
  ];

  const primaryColor = useWidgetStore((state) => state.config.primaryColor);
  const setPrimaryColor = useWidgetStore((state) => state.setPrimaryColor);

  const colorInputRef = useRef<HTMLInputElement>(null);

  const handleEyedropperClick = () => {
    colorInputRef.current?.click();
  };

  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const color = e.target.value;
    setPrimaryColor(color);
  };

  return (
    // <div className="cy:space-y-3">
    //   <div className="cy:flex cy:items-center cy:space-x-2">
    //     <Label>Primary Color</Label>
    //     <TooltipWrapper content="Choose a WCAG compliant color with proper contrast ratios" />
    //   </div>
    //   <div className="cy:flex cy:items-center cy:space-x-3">
    //     <Input
    //       type="color"
    //       value={primaryColor}
    //       onChange={(e) => setPrimaryColor(e.target.value)}
    //       className="cy:w-16 cy:h-10 cy:p-1 cy:border cy:rounded"
    //     />
    //     <Input
    //       type="text"
    //       value={primaryColor}
    //       onChange={(e) => setPrimaryColor(e.target.value)}
    //       className="cy:flex-1"
    //     />
    //   </div>
    // </div>
    <div>
      {/* Color input box */}
      <div className="cy:flex cy:items-center cy:border-1 cy:rounded-sm cy:px-3 cy:py-2 cy:w-[190px] cy:mb-3">
        <div
          className="cy:w-6 cy:h-6 cy:rounded cy:mr-3"
          style={{ background: primaryColor }}
        />
        <span className="cy:text-md">{primaryColor.toUpperCase()}</span>
      </div>

      {/* Swatches */}
      <div className="cy:flex cy:items-center cy:space-x-3 cy:mt-2 cy:relative">
        {COLORS.map((color) => (
          <button
            key={color}
            className={`cy:w-10 cy:h-10 cy:rounded-full cy:border-4 ${
              primaryColor === color
                ? "cy:border-[#C7C9D9]"
                : "cy:border-[#E3E6F0]"
            } cy:flex cy:items-center cy:justify-center cy:transition cy:relative`}
            style={{ background: color }}
            onClick={() => setPrimaryColor(color)}
            aria-label={color}
          >
            {primaryColor === color && (
              <Check className="cy:w-5 cy:h-5 cy:text-white cy:absolute" />
            )}
          </button>
        ))}
        {/* Eyedropper */}
        <button
          type="button"
          className="cy:w-10 cy:h-10 cy:rounded-full cy:border-4 cy:border-[#E3E6F0] cy:flex cy:items-center cy:justify-center cy:bg-[#ECF3FC]"
          aria-label="Pick custom color"
          onClick={handleEyedropperClick}
        >
          <PipetteIcon className="cy:w-4 cy:h-4 text-[#4E4B66]" />
        </button>
        <input
          ref={colorInputRef}
          type="color"
          className="cy:absolute cy:top-0 cy:left-0 cy:w-0 cy:h-0"
          onChange={handleColorChange}
          aria-label="Color picker"
        />
       
      </div>
      <div className="cy:flex cy:mt-2">
          <p className="cy:text-[10px] cy:text-[#535276]">
            Heads up: We recommend checking your colour choice against WCAG AA contrast guidelines to ensure accessibility. {" "}
            <a
              href="https://www.wcagcontrastchecker.com/"
              target="_blank"
              className="cy:text-blue-600 cy:underline cy:hover:text-blue-800"
            >
              Check contrast here →
            </a>
          </p>
        </div>
    </div>
  );
}
